import BaseChartOptions from '../../../utils/BaseChart/BaseChartOptions';

class BrandPriceLadderChartOptions extends BaseChartOptions {
    constructor(data: Array<any>, barIDs: string[], pointIDs: string[]) {
        super(data);
        const children = [
            ...barIDs.map((id) => ({ id, type: 'interval' })),
            ...pointIDs.map((id) => ({ id, type: 'point' })),
        ];
        this.setChildren(children);
    }
}

export default BrandPriceLadderChartOptions;


